import React, { Component } from "react";
import { Link } from "react-router-dom";
import upcommingcalls from '../../assets/icons/svg/upcoming-calls.svg';
import requesttoberescheduled from '../../assets/icons/svg/requested-to-be-resceduled.svg';
import myclaimedcalls from '../../assets/icons/svg/my-claimed-calls.svg';
import duecalls from '../../assets/icons/svg/due-calls.svg';
import activecalls from '../../assets/icons/svg/active-calls.svg';
import scheduledappointments from '../../assets/icons/svg/scheduled-appointments.svg';
import nonresponsivecalls from '../../assets/icons/svg/non-responsive-calls.svg';
import notinterested from '../../assets/icons/dashboard/sad.png'
import badphonenumber from '../../assets/icons/svg/bad-phone-number.svg'
import AgencyModal from "./parts/reviewscheduler/dedicated-agency-modal";



import {
  Row,
  Col,
  Icon,
  DatePicker,
  Select,
  Button,
  message,
  Tooltip,
  Input,
  Spin
} from "antd";
import moment from "moment";
import F from "../../Functions";
import axios from "axios";
import CommonHeader from "./CommonHeader";
import { Translate } from "react-translated";
import { debounceQuery, get_label_from_value, REVIEWSCHEDULER, VONBOARDER, VONSCHEDULER } from "../../utils/Constants";
import { DESC } from "../../utils/Constants";
import SetupAppointment from "../LandingPage/parts/setup-appointment-modal-vo";
import Collapse from "../../Collapse";
import ShowHideStats from "./parts/show-hide-stats";
import {
  BFILE_API_URL, GET_FS_DASHBOARD_CALLS_V2, GET_FS_DASHBOARD_CALLS_V5, GET_FS_DASHBOARD_NON_RESPONSIVE_NOT_INTERESTED,
  GET_RS_USER_AGENCIES, MY_VONBOARD_BFILE_API_URL,
  VONBOARDER_AGENCIES_API_URL
} from "../../utils/Api_enums";
import Cookies from "js-cookie";

// store 
import { useBoundStore } from '../../store/useBoundStore';
import { attachRangePickerCloseButton } from '../../utils/rangePickerCloseButton';


const Option = Select.Option;
const { RangePicker } = DatePicker;
const today = new Date();
const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;


class Vonboard extends Component {

  state = {
    isDefaultDateApplied: false,
    role: null,
    // role: null,
    loading: false,
    period: "all_bfiles",
    isLoading: true,
    start_date: "2010-01-01",
    end_date: "2050-01-01",
    typeOfCall: null,
    selectedFilterOption: "AllBFiles",
    filterOption: null,
    selectedAgency: null,
    selectedToggle: null,
    selectedToggleAPI: null,
    datemodified: null,
    loggedInUserType: "",
    isReview: false,
    open: false,
    hideBadPhoneNumber: useBoundStore.getState().RSFSCardFilters.hideBadPhoneNumber !== undefined
      ? useBoundStore.getState().RSFSCardFilters.hideBadPhoneNumber
      : 1,
    buckets: [
      {
        order: 0,
        index: 4,
        direction: DESC,
        order_by: 'expiration_date',
        title: "Upcoming Calls",
        dashboard_stats: "upcoming_calls",
        description: "Profiles for which the active call date and schedule-by date are in the future.",
        icon: upcommingcalls,
        role: VONBOARDER,
        isLiveGrid: true,
        canClaimBFile: true,
        quickNavigation: true,
        isClickable: false,
        isFSUser: true
      },
      {
        order: 1,
        index: 2,
        direction: DESC,
        order_by: 'expiration_date',
        title: "Due Calls",
        dashboard_stats: "due_calls",
        description: "Profiles with present or expired active call date and are due to be scheduled.",
        icon: duecalls,
        role: VONBOARDER,
        isLiveGrid: true,
        canClaimBFile: true,
        quickNavigation: true,
        isClickable: true,
        isFSUser: true
      },
      {
        order: 2,
        index: 7,
        direction: DESC,
        order_by: 'von_appointment_date',
        title: "Scheduled Appointments",
        dashboard_stats: "appointments_scheduled",
        icon: scheduledappointments,
        description: "Profiles for which appointments scheduled in the selected time frame.",
        role: VONBOARDER,
        isLiveGrid: true,
        quickNavigation: true,
        isClickable: true,
        isFSUser: true
      },
      {
        order: 3,
        index: 1,
        direction: DESC,
        order_by: 'expiration_date',
        title: "Active Calls",
        dashboard_stats: "active_calls",
        description: "Profiles marked as not reached and their schedule-by date is not expired.",
        icon: activecalls,
        role: VONBOARDER,
        isLiveGrid: true,
        quickNavigation: true,
        isClickable: true,
        isFSUser: true
      },
      {
        order: 4,
        index: 5,
        direction: DESC,
        order_by: 'von_appointment_date',
        title: "Non Responsive Calls",
        dashboard_stats: "non_responsive",
        // dashboard_stats: "not_reached",
        icon: nonresponsivecalls,
        description: "Profiles marked as non-responsive or the ones marked as not reached with expired schedule-by date.",
        role: VONBOARDER,
        isLiveGrid: true,
        quickNavigation: true,
        isClickable: true,
        isFSUser: true
      },
      {
        order: 5,
        index: 8,
        direction: DESC,
        order_by: 'von_appointment_date',
        title: "Requested To Be Re-Scheduled",
        dashboard_stats: "requested_reschedule",
        description: "Profiles for which agents have requested appointment rescheduling.",
        icon: requesttoberescheduled,
        role: VONBOARDER,
        isLiveGrid: true,
        quickNavigation: true,
        isClickable: true,
        isFSUser: true
      },
      {
        order: 6,
        index: 3,
        direction: DESC,
        order_by: 'von_appointment_date',
        title: "Not Interested",
        dashboard_stats: "not_interested",
        description: "Profiles that are marked as not interested.",
        icon: notinterested,
        role: VONBOARDER,
        isLiveGrid: true,
        quickNavigation: true,
        isClickable: true,
        isFSUser: true
      },
      // {
      //   order: 7,
      //   index: 0,
      //   direction: DESC,
      //   order_by: 'expiration_date',
      //   title: "My Claimed Calls",
      //   dashboard_stats: "claimed_calls",
      //   icon: myclaimedcalls,
      //   description: "Profiles you claimed to schedule appointments for.",
      //   role: VONBOARDER,
      //   isLiveGrid: true,
      //   quickNavigation: true,
      //   isClickable: true,
      //   isFSUser: true
      // },
      {
        order: 8,
        index: 6,
        direction: DESC,
        order_by: 'von_appointment_date',
        title: "Bad Phone Numbers",
        dashboard_stats: "bad_phones_numbers",
        description: "Profiles that are reported to have bad phone number.",
        icon: badphonenumber,
        role: VONBOARDER,
        quickNavigation: true,
        isClickable: true,
        isFSUser: true
        // isLiveGrid: true
      },
    ],

    agency_id: 0,
    user: this.props.auth.user,
    agencies: [],
    stats: {},
    stats_loading: false,
    dedicated_agency_modal: false,
    setup_appointment_modal: false,
    bfile: null
  };

  cokkieData = typeof Cookies.get("user_info") !== "undefined"
    ? JSON.parse(Cookies.get("user_info"))
    : {};

  roles = JSON.parse(localStorage.getItem('roles'));



  constructor(props) {
    super(props); // Call super first!
    this.state = {
      loading: false,
      typeOfCall: null,
      period: "all_bfiles",
      start_date: "2010-01-01",
      end_date: "2050-01-01",
      buckets: [],
      datemodified: {
        start_date: "2010-01-01",
        end_date: "2050-01-01"
      },
      selectedFilterOption: "AllBFiles",
      filterOption: null,
      agency_id: 0,
      user: this.props.auth.user,
      agencies: [],
      stats: {},
      stats_loading: false,
      dedicated_agency_modal: false,
      setup_appointment_modal: false,
      bfile: null,// Call function inside constructor,
      selectedButton: useBoundStore.getState().RSFSCardFilters.selectedButton || 'AllBFiles',
    };
    this.unsubscribe = null;
  }







  handleRefresh = () => {
    const defaultFilters = {
      selectedAgency: undefined,
      selectedFilterOption: "AllBFiles",
      datemodified: {
        start_date: "2010-01-01",
        end_date: "2050-01-01",
      },
      selectedButton: "AllBFiles",
      selectedAgencyName: undefined
    };

    this.setState(defaultFilters);
    useBoundStore.getState().setRSFSCardFilters(defaultFilters);
    this.getStatsData();
  };

  getRSDashboardStats = async () => {
    try {
      this.setState({ isLoading: true });

      const storeState = useBoundStore.getState();
      const filters = storeState.RSFSCardFilters;

      const agencyId = filters.selectedAgency || this.state.agency_id;
      const from = filters.datemodified.start_date || this.state.start_date;
      const to = filters.datemodified.end_date || this.state.end_date;
      const userType = REVIEWSCHEDULER;
      let typeOfCall = filters.selectedFilterOption || this.state.typeOfCall;
      typeOfCall = typeOfCall == 'AllBFiles' ? null : typeOfCall;


      const BFILE_API_URL = "api/rs_user_dashboard_stats";
      const params = {
        from,
        to,
        user_type: userType,
        ...(typeOfCall ? { type_of_call: typeOfCall } : {}),
        ...(agencyId ? { agency_id: agencyId } : {}),
        ...(filters.hideBadPhoneNumber ? { bad_phone_number_status: false } : {})
      };
      const queryString = new URLSearchParams(params).toString();
      const url = `${BFILE_API_URL}?${queryString}`;

      const response = await axios.get(url);
      const stats = response.data;

      this.setState((prevState) => {
        const updatedBuckets = prevState.buckets.map((bucket) => ({
          ...bucket,
          calls: stats[bucket.dashboard_stats] || 0,
        }));
        return { buckets: updatedBuckets };
      });

    } catch (error) {
      this.setState({ isLoading: false });
      console.error("Error fetching dashboard stats:", error);
    }
  };



  getFSDashboardStats = async () => {
    const hasFollowUp = this.roles.includes("FollowUp");
    const hasProspect = this.roles.includes("Prospect");

    let role = null;
    if (hasFollowUp && !hasProspect) {
      role = "FollowUp";
    } else if (!hasFollowUp && hasProspect) {
      role = "Prospect";
    }

    const storeState = useBoundStore.getState();
    const filters = storeState.RSFSCardFilters;

    let type_of_call;
    const agencyId = filters.selectedAgency || this.state.agency_id;
    const from = filters.datemodified.start_date || this.state.start_date;
    const to = filters.datemodified.end_date || this.state.end_date;
    const userType = VONBOARDER;

    if (role) {
      type_of_call = role;
    } else {
      type_of_call = filters.selectedFilterOption || this.state.typeOfCall;
    }

    type_of_call = type_of_call === "AllBFiles" ? null : type_of_call;

    this.setState({ isLoading: true });

    const params = {
      from,
      to,
      user_type: userType,
      ...(type_of_call ? { type_of_call } : {}),
      ...(agencyId ? { agency_id: agencyId } : {}),
      ...(filters.hideBadPhoneNumber ? { bad_phone_number_status: false } : {}),
    };

    const queryString = new URLSearchParams(params).toString();

    const url1 = `${GET_FS_DASHBOARD_CALLS_V5}?${queryString}`;
    const url2 = `${GET_FS_DASHBOARD_NON_RESPONSIVE_NOT_INTERESTED}?${queryString}`;

    try {

      const [res1, res2] = await Promise.all([axios.get(url1), axios.get(url2)]);


      const stats = { ...res1.data, ...res2.data };

      this.setState((prevState) => {
        const updatedBuckets = prevState.buckets.map((bucket) => ({
          ...bucket,
          calls: stats[bucket.dashboard_stats] || 0,
        }));
        return { buckets: updatedBuckets, isLoading: false };
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };



  // getFSDashboardStats = async () => {

  //   const hasFollowUp = this.roles.includes("FollowUp");
  //   const hasProspect = this.roles.includes("Prospect");

  //   let role = null;
  //   if (hasFollowUp && !hasProspect) {
  //     role = "FollowUp";
  //   } else if (!hasFollowUp && hasProspect) {
  //     role = "Prospect";
  //   }


  //   const storeState = useBoundStore.getState();
  //   const filters = storeState.RSFSCardFilters;
  //   let type_of_call;
  //   const agencyId = filters.selectedAgency || this.state.agency_id;
  //   const from = filters.datemodified.start_date || this.state.start_date;
  //   const to = filters.datemodified.end_date || this.state.end_date;
  //   const userType = VONBOARDER;
  //   if (role) {
  //     type_of_call = role
  //   } else {
  //     type_of_call = filters.selectedFilterOption || this.state.typeOfCall;
  //   }

  //   type_of_call = type_of_call == 'AllBFiles' ? null : type_of_call;

  //   this.setState({ isLoading: true });

  //   const BFILE_API_URL = GET_FS_DASHBOARD_CALLS_V5;
  //   const params = {
  //     from,
  //     to,
  //     user_type: userType,
  //     ...(type_of_call ? { type_of_call: type_of_call } : {}),
  //     ...(agencyId ? { agency_id: agencyId } : {})
  //   };
  //   const queryString = new URLSearchParams(params).toString();
  //   const url = `${BFILE_API_URL}?${queryString}`;

  //   await axios.get(url).then(
  //     (response) => {
  //       const stats = response.data;
  //       this.setState((prevState) => {
  //         const updatedBuckets = prevState.buckets.map((bucket) => ({
  //           ...bucket,
  //           calls: stats[bucket.dashboard_stats] || 0,
  //         }));
  //         return { buckets: updatedBuckets, isLoading: false };
  //       });
  //     },
  //     (error) => {
  //       this.setState({ isLoading: false });
  //     }
  //   );
  // };


  handleResetFilters = () => {
    useBoundStore.getState().resetRSFSFilters();
  };

  handleBadPhoneNumberToggle = (event) => {
    const hideBadPhoneNumber = event.target.checked ? 1 : 0;
    useBoundStore.getState().setRSFSCardFilters({ hideBadPhoneNumber });
    useBoundStore.getState().setRSFSFilters({ hideBadPhoneNumber });
    this.setState({ hideBadPhoneNumber }, () => this.getStatsData());
  };


  handleCardClick = (card, index) => {
    this.handleResetFilters();
    const rsFSCardFilter = useBoundStore.getState().RSFSCardFilters;
    useBoundStore.getState().setRSFSFilters({
      selectedButton: rsFSCardFilter.selectedButton,
      selectedAgency: rsFSCardFilter.selectedAgency,
      selectedAgencyName: rsFSCardFilter.selectedAgencyName,
      selectedFilterOption: rsFSCardFilter.selectedFilterOption,
      hideBadPhoneNumber: rsFSCardFilter.hideBadPhoneNumber,
      datemodified: rsFSCardFilter.datemodified || {
        start_date: null,
        end_date: null
      }
    });
    localStorage.setItem('card', JSON.stringify(card));
    this.props.history.push({
      pathname: '/dashboard/rsfs-grid',
      search: `?title=${encodeURIComponent(card.title)}`,
      state: { card: card }
    });
  };


  componentDidMount = () => {
    const zustandState = useBoundStore.getState().RSFSCardFilters;

    this.setState({
      selectedAgency: zustandState.selectedAgency,
      selectedFilterOption: zustandState.selectedFilterOption,
      datemodified: zustandState.datemodified,
      selectedToggle: zustandState.selectedToggle,
      selectedToggleAPI: zustandState.selectedToggleAPI,
      hideBadPhoneNumber: zustandState.hideBadPhoneNumber
    });

    this.unsubscribe = useBoundStore.subscribe((state) => {
      this.setState({
        selectedAgency: state.RSFSCardFilters.selectedAgency,
        selectedFilterOption: state.RSFSCardFilters.selectedFilterOption,
        datemodified: state.RSFSCardFilters.datemodified,
        selectedToggle: state.RSFSCardFilters.selectedToggle,
        selectedToggleAPI: state.RSFSCardFilters.selectedToggleAPI,
        hideBadPhoneNumber: state.RSFSCardFilters.hideBadPhoneNumber
      });
    });


    this.setState({
      filterOption: this.getFilterOption()
    });

    this.getStatsData();
  };


  showSelectionFilterOptionDropdown = () => {
    const { roles, state } = this;
    const hasFollowUp = roles.includes("FollowUp");
    const hasProspect = roles.includes("Prospect");
    return state.selectedToggleAPI === VONBOARDER && hasFollowUp && hasProspect;
  };


  showAllBFilesButton = () => {
    const hasFollowUp = this.roles.includes("FollowUp");
    const hasProspect = this.roles.includes("Prospect");
    const hasReview = this.roles.includes("Review");
    if (this.state.selectedToggleAPI === REVIEWSCHEDULER) {
      return true;
    }
    if (this.state.selectedToggleAPI === VONBOARDER) {
      return !(hasFollowUp && hasProspect);
    }
    return false;
  };



  getFilterOption = () => {
    let arr = [];
    const zustandState = useBoundStore.getState().RSFSCardFilters;
    let selectedToggleAPI = zustandState.selectedToggleAPI;

    const hasFollowUp = this.roles.includes("FollowUp");
    const hasProspect = this.roles.includes("Prospect");
    const hasReview = this.roles.includes("Review");

    if (!selectedToggleAPI) {
      if (hasReview) {
        selectedToggleAPI = REVIEWSCHEDULER;
      } else {
        selectedToggleAPI = VONBOARDER;
      }
      useBoundStore.getState().setRSFSCardFilters({ selectedToggleAPI });
    }

    if (selectedToggleAPI === REVIEWSCHEDULER) {
      arr.push({ id: 1, key: "AllBFiles", value: "All B Files" });
      this.setState({
        buckets: this.getBucketOnHandleRoleChange(selectedToggleAPI),
      });
    } else {
      if (hasFollowUp && hasProspect) {
        arr.push({ id: 1, key: "AllBFiles", value: "All B Files" });
      }
      if (hasProspect) {
        arr.push({ id: 2, key: "Prospect", value: "Leads" });
      }
      if (hasFollowUp) {
        arr.push({ id: 3, key: "FollowUp", value: "Opportunities" });
      }
      this.setState({
        buckets: this.getBucketOnHandleRoleChange(selectedToggleAPI),
      });
    }

    return arr;
  };






  rsFilter = () => {
    let arr = [];
    if (this.roles.includes("Review")) {
      arr.push({ id: 1, key: "AllBFiles", value: "All B Files" });
    }
    return arr;
  }

  fsFilter = () => {
    const arr = [];
    const { roles } = this;

    const hasFollowUp = roles.includes("FollowUp");
    const hasProspect = roles.includes("Prospect");
    const hasReview = roles.includes("Review");


    const filters = {
      allBFiles: { id: 1, key: "AllBFiles", value: "All B Files" },
      prospect: { id: 2, key: "Prospect", value: "Leads" },
      followUp: { id: 3, key: "FollowUp", value: "Opportunities" }
    };


    if (hasFollowUp && hasProspect) {
      arr.push(filters.allBFiles, filters.prospect, filters.followUp);
    } else if (hasFollowUp && hasReview) {
      arr.push(filters.allBFiles, filters.followUp);
    } else if (hasProspect && hasReview) {
      arr.push(filters.allBFiles, filters.prospect);
    } else {

      if (hasFollowUp) arr.push(filters.followUp);
      if (hasProspect) arr.push(filters.prospect);
      if (hasReview) arr.push(filters.allBFiles);
    }

    return arr;
  }


  fetchDataForReviewScheduler = async () => {
    this.setState({ agencies: [], isLoading: true });

    try {
      const agencyResponse = await axios.get(GET_RS_USER_AGENCIES, {
        params: { user_type: REVIEWSCHEDULER }
      });

      let defaultStart = "2010-01-01";
      let defaultEnd = moment().format("YYYY-MM-DD");

      if (agencyResponse.data.length > 0) {

        const store = useBoundStore.getState().RSFSCardFilters;
        const selectedAgencyId = store.selectedAgency;

        let targetAgency = null;

        //1. If user selected agency → use that
        if (selectedAgencyId) {
          targetAgency = agencyResponse.data.find(
            (a) => Number(a.id) === Number(selectedAgencyId)
          );
        }

        //  2. fallback → oldest agency
        if (!targetAgency) {
          targetAgency = agencyResponse.data.reduce((oldest, current) =>
            moment(current.start_date).isBefore(moment(oldest.start_date))
              ? current
              : oldest
          );
        }

        const safeStartDate =
          targetAgency && targetAgency.start_date &&
            moment(targetAgency.start_date, moment.ISO_8601, true).isValid()
            ? targetAgency.start_date
            : "2010-01-01";

        defaultStart = moment(safeStartDate).format("YYYY-MM-DD");

        // defaultStart = moment(targetAgency.start_date).format("YYYY-MM-DD");
      }

      const updatedDates = {
        start_date: defaultStart,
        end_date: defaultEnd
      };

      const store = useBoundStore.getState().RSFSCardFilters;

      const hasUserFiltered =
        store.selectedButton &&
        store.selectedButton !== "AllBFiles";

      this.setState({
        agencies: agencyResponse.data,

        //  do not override user filters
        start_date: hasUserFiltered ? this.state.start_date : defaultStart,
        end_date: hasUserFiltered ? this.state.end_date : defaultEnd,

        datemodified: hasUserFiltered
          ? this.state.datemodified
          : updatedDates
      });

      //  sync only when no user filters applied
      if (!hasUserFiltered) {
        useBoundStore.getState().setRSFSCardFilters({
          datemodified: updatedDates
        });
        useBoundStore.getState().setRSFSFilters({
          datemodified: updatedDates
        });
      }

      await this.getRSDashboardStats();

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  // fetchDataForReviewScheduler = async () => {
  //   this.setState({ agencies: [], isLoading: true });
  //   try {
  //     const [agencyResponse, statsResponse] = await Promise.all([
  //       axios.get(GET_RS_USER_AGENCIES, {
  //         params: { user_type: REVIEWSCHEDULER }
  //       }),
  //       this.getRSDashboardStats()
  //     ]);

  //     this.setState({
  //       agencies: agencyResponse.data,
  //     });
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     this.setState({ isLoading: false });
  //   }
  // };


  fetchDataForFollowUpSpecialist = async () => {
    this.setState({ agencies: [], isLoading: true });

    try {
      const agencyResponse = await axios.get(VONBOARDER_AGENCIES_API_URL, {
        params: { user_type: VONBOARDER }
      });

      let defaultStart = "2010-01-01";
      let defaultEnd = moment().format("YYYY-MM-DD");

      if (agencyResponse.data.length > 0) {

        const store = useBoundStore.getState().RSFSCardFilters;
        const selectedAgencyId = store.selectedAgency;

        let targetAgency = null;

        //1. If user selected agency → use that
        if (selectedAgencyId) {
          targetAgency = agencyResponse.data.find(
            (a) => Number(a.id) === Number(selectedAgencyId)
          );
        }

        //  2. fallback → oldest agency
        if (!targetAgency) {
          targetAgency = agencyResponse.data.reduce((oldest, current) =>
            moment(current.start_date).isBefore(moment(oldest.start_date))
              ? current
              : oldest
          );
        }


        const safeStartDate =
          targetAgency && targetAgency.start_date &&
            moment(targetAgency.start_date, moment.ISO_8601, true).isValid()
            ? targetAgency.start_date
            : "2010-01-01";

        defaultStart = moment(safeStartDate).format("YYYY-MM-DD");

        // defaultStart = moment(targetAgency.start_date).format("YYYY-MM-DD");
      }

      const updatedDates = {
        start_date: defaultStart,
        end_date: defaultEnd
      };

      const store = useBoundStore.getState().RSFSCardFilters;

      const hasUserFiltered =
        store.selectedButton &&
        store.selectedButton !== "AllBFiles";

      this.setState({
        agencies: agencyResponse.data,

        //  do not override user filters
        start_date: hasUserFiltered ? this.state.start_date : defaultStart,
        end_date: hasUserFiltered ? this.state.end_date : defaultEnd,

        datemodified: hasUserFiltered
          ? this.state.datemodified
          : updatedDates
      });

      //  sync only when no user filters applied
      if (!hasUserFiltered) {
        useBoundStore.getState().setRSFSCardFilters({
          datemodified: updatedDates
        });
        useBoundStore.getState().setRSFSFilters({
          datemodified: updatedDates
        })
      }

      await this.getFSDashboardStats();
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  // fetchDataForFollowUpSpecialist = async () => {
  //   this.setState({ agencies: [], isLoading: true });

  //   try {
  //     const [agencyResponse, statsResponse] = await Promise.all([
  //       axios.get("/api/vonboarder_lead_opp_agencies", {
  //         params: { user_type: VONBOARDER }
  //       }),
  //       this.getFSDashboardStats(),
  //     ]);

  //     this.setState({
  //       agencies: agencyResponse.data,
  //     });
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   } finally {
  //     this.setState({ isLoading: false });
  //   }
  // };



  getRSBuckets = () => [
    {
      order: 0,
      index: 4,
      direction: DESC,
      order_by: 'expiration_date',
      title: "Upcoming Calls",
      dashboard_stats: "upcoming_calls",
      description: "Profiles for which the active call date and schedule-by date are in the future.",
      icon: upcommingcalls,
      role: REVIEWSCHEDULER,
      isLiveGrid: true,
      isClickable: false,
      quickNavigation: true,
      isRSUser: true
    },
    {
      order: 1,
      index: 2,
      direction: DESC,
      order_by: 'expiration_date',
      title: "Due Calls",
      dashboard_stats: "due_calls",
      description: "Profiles with present or expired active call date and are due to be scheduled.",
      icon: duecalls,
      role: REVIEWSCHEDULER,
      isLiveGrid: true,
      isClickable: true,
      quickNavigation: true,
      isRSUser: true
    },
    {
      order: 2,
      index: 7,
      direction: DESC,
      order_by: 'von_appointment_date',
      title: "Scheduled Appointments",
      dashboard_stats: "appointments_scheduled",
      icon: scheduledappointments,
      description: "Profiles for which appointments scheduled in the selected time frame.",
      role: REVIEWSCHEDULER,
      isLiveGrid: true,
      isClickable: true,
      quickNavigation: true,
      isRSUser: true
    },
    {
      order: 3,
      index: 1,
      direction: DESC,
      order_by: 'expiration_date',
      title: "Active Calls",
      dashboard_stats: "active_calls",
      description: "Profiles marked as not reached and their schedule-by date is not expired.",
      icon: activecalls,
      role: REVIEWSCHEDULER,
      isLiveGrid: true,
      isClickable: true,
      quickNavigation: true,
      isRSUser: true
    },
    {
      order: 4,
      index: 5,
      direction: DESC,
      order_by: 'von_appointment_date',
      title: "Non Responsive Calls",
      dashboard_stats: "non_responsive_calls",
      icon: nonresponsivecalls,
      description: "Profiles marked as non-responsive or the ones marked as not reached with expired schedule-by date.",
      role: REVIEWSCHEDULER,
      isLiveGrid: true,
      isClickable: true,
      quickNavigation: true,
      isRSUser: true
    },
    {
      order: 5,
      index: 8,
      direction: DESC,
      order_by: 'von_appointment_date',
      title: "Requested To Be Re-Scheduled",
      dashboard_stats: "requested_reschedules",
      description: "Profiles for which agents have requested appointment rescheduling.",
      icon: requesttoberescheduled,
      role: REVIEWSCHEDULER,
      isLiveGrid: true,
      isClickable: true,
      quickNavigation: true,
      isRSUser: true
    },
    {
      order: 6,
      index: 3,
      direction: DESC,
      order_by: 'von_appointment_date',
      title: "Not Interested",
      dashboard_stats: "not_interested",
      description: "Profiles that are marked as not interested.",
      icon: notinterested,
      role: REVIEWSCHEDULER,
      isLiveGrid: true,
      isClickable: true,
      quickNavigation: true,
      isRSUser: true
    },
    {
      order: 8,
      index: 6,
      direction: DESC,
      order_by: 'von_appointment_date',
      title: "Bad Phone Numbers",
      dashboard_stats: "bad_phone_number",
      description: "Profiles that are reported to have bad phone number.",
      icon: badphonenumber,
      role: REVIEWSCHEDULER,
      isClickable: true,
      quickNavigation: true,
      isRSUser: true
      // isLiveGrid: true
    },
  ];

  getFSBuckets = () => [
    {
      order: 0,
      index: 4,
      direction: DESC,
      order_by: 'expiration_date',
      title: "Upcoming Calls",
      dashboard_stats: "upcoming_calls",
      description: "Profiles with active call date and schedule-by date in future.",
      icon: upcommingcalls,
      role: VONBOARDER,
      isLiveGrid: true,
      canClaimBFile: true,
      quickNavigation: true,
      isClickable: false,
      isFSUser: true
    },
    {
      order: 1,
      index: 2,
      direction: DESC,
      order_by: 'expiration_date',
      title: "Due Calls",
      dashboard_stats: "due_calls",
      description: "Profiles with present or expired active call date and are due to be scheduled.",
      icon: duecalls,
      role: VONBOARDER,
      isLiveGrid: true,
      canClaimBFile: true,
      isClickable: true,
      quickNavigation: true,
      isFSUser: true
    },
    {
      order: 2,
      index: 7,
      direction: DESC,
      order_by: 'von_appointment_date',
      title: "Scheduled Appointments",
      dashboard_stats: "appointments_scheduled",
      icon: scheduledappointments,
      description: "Profiles for which appointments scheduled in the selected time frame.",
      role: VONBOARDER,
      isLiveGrid: true,
      isClickable: true,
      quickNavigation: true,
      isFSUser: true
    },
    {
      order: 3,
      index: 1,
      direction: DESC,
      order_by: 'expiration_date',
      title: "Active Calls",
      dashboard_stats: "active_calls",
      description: "Profiles marked as not reached and their schedule-by date is not expired.",
      icon: activecalls,
      role: VONBOARDER,
      isLiveGrid: true,
      isClickable: true,
      quickNavigation: true,
      isFSUser: true
    },
    {
      order: 4,
      index: 5,
      direction: DESC,
      order_by: 'von_appointment_date',
      title: "Non Responsive Calls",
      dashboard_stats: "non_responsive",
      //dashboard_stats: "not_reached",
      icon: nonresponsivecalls,
      description: "Profiles marked as non-responsive or the ones marked as not reached with expired schedule-by date.",
      role: VONBOARDER,
      isLiveGrid: true,
      isClickable: true,
      quickNavigation: true,
      isFSUser: true
    },
    {
      order: 5,
      index: 8,
      direction: DESC,
      order_by: 'von_appointment_date',
      title: "Requested To Be Re-Scheduled",
      dashboard_stats: "requested_reschedule",
      description: "Profiles for which agents have requested appointment rescheduling.",
      icon: requesttoberescheduled,
      role: VONBOARDER,
      isLiveGrid: true,
      isClickable: true,
      quickNavigation: true,
      isFSUser: true
    },
    {
      order: 6,
      index: 3,
      direction: DESC,
      order_by: 'von_appointment_date',
      title: "Not Interested",
      dashboard_stats: "not_interested",
      description: "Profiles that are marked as not interested.",
      icon: notinterested,
      role: VONBOARDER,
      isLiveGrid: true,
      isClickable: true,
      quickNavigation: true,
      isFSUser: true
    },
    // {
    //   order: 7,
    //   index: 0,
    //   direction: DESC,
    //   order_by: 'expiration_date',
    //   title: "My Claimed Calls",
    //   dashboard_stats: "claimed_calls",
    //   icon: myclaimedcalls,
    //   description: "Profiles you claimed to schedule appointments for.",
    //   role: VONBOARDER,
    //   isLiveGrid: true,
    //   isClickable: true,
    //   quickNavigation: true,
    //   isFSUser: true
    // },
    {
      order: 8,
      index: 6,
      direction: DESC,
      order_by: 'von_appointment_date',
      title: "Bad Phone Numbers",
      dashboard_stats: "bad_phones_numbers",
      description: "Profiles that are reported to have bad phone number.",
      icon: badphonenumber,
      role: VONBOARDER,
      isClickable: true,
      quickNavigation: true,
      isFSUser: true
      //  isLiveGrid: true
    },
  ];

  getBucketOnHandleRoleChange = (newRole) => {
    if (newRole === REVIEWSCHEDULER) {
      return this.getRSBuckets();
    } else if (newRole === VONBOARDER) {
      return this.getFSBuckets();
    }
    return [];
  };


  getStatsData = () => {
    const zustandState = useBoundStore.getState().RSFSCardFilters;
    let selectedToggleAPI = zustandState.selectedToggleAPI;

    if (selectedToggleAPI) {
      if (selectedToggleAPI == REVIEWSCHEDULER) {
        this.fetchDataForReviewScheduler();
      } else {
        this.fetchDataForFollowUpSpecialist();
      }
    } else {
      if (this.roles.includes("Review")) {
        this.fetchDataForReviewScheduler();
      } else if (this.roles.includes("FollowUp") || this.roles.includes("Prospect")) {
        this.fetchDataForFollowUpSpecialist();
      } else {
        this.fetchDataForReviewScheduler();
      }
    }
  }




  componentDidUpdate(prevProps, prevState) {
    if (this.state.open && !prevState.open) {
      this._cleanupRangePickerCloseBtn = attachRangePickerCloseButton(() =>
        this.setState({ open: false })
      );
    } else if (!this.state.open && prevState.open && this._cleanupRangePickerCloseBtn) {
      this._cleanupRangePickerCloseBtn();
      this._cleanupRangePickerCloseBtn = null;
    }
  }

  componentWillUnmount() {
    if (this._cleanupRangePickerCloseBtn) {
      this._cleanupRangePickerCloseBtn();
      this._cleanupRangePickerCloseBtn = null;
    }
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }


  handleThisMonth = () => {
    const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
    const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");

    const updatedDates = {
      start_date: startOfMonth,
      end_date: endOfMonth,
    };

    useBoundStore.getState().setRSFSCardFilters({
      datemodified: updatedDates,
      selectedButton: "ThisMonth"
    });

    this.setState({
      start_date: startOfMonth,
      end_date: endOfMonth,
      datemodified: updatedDates,
      selectedButton: "ThisMonth"
    }, () => {
      this.getStatsData();
    });
  };



  // handleThisMonth = () => {
  //   const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  //   const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");

  //   useBoundStore.getState().setRSFSCardFilters({
  //     datemodified: {
  //       start_date: startOfMonth,
  //       end_date: endOfMonth,
  //     },
  //     selectedButton: 'ThisMonth'
  //   });


  //   this.setState({
  //     start_date: startOfMonth,
  //     end_date: endOfMonth,
  //     selectedButton: "ThisMonth"
  //   });
  //   this.getStatsData();
  // };



  handleAllBFiles = () => {
    let startDate = moment().format("YYYY-MM-DD");
    let endDate = moment().format("YYYY-MM-DD");

    // For Review Scheduler use oldest agency date
    if (
      this.state.selectedToggleAPI === REVIEWSCHEDULER &&
      this.state.agencies.length > 0
    ) {
      const oldestAgency = this.state.agencies.reduce((oldest, current) =>
        moment(current.start_date).isBefore(moment(oldest.start_date))
          ? current
          : oldest
      );

      startDate = moment(oldestAgency.start_date).format("YYYY-MM-DD");
    }

    const updatedDates = {
      start_date: startDate,
      end_date: endDate
    };

    useBoundStore.getState().setRSFSCardFilters({
      datemodified: updatedDates,
      selectedFilterOption: undefined,
      selectedButton: "AllBFiles"
    });

    this.setState({
      start_date: startDate,
      end_date: endDate,
      datemodified: updatedDates,
      selectedButton: "AllBFiles"
    }, () => {
      this.getStatsData();
    });
  };

  // handleAllBFiles = () => {
  //   let value = undefined;
  //   const startOfMonth = "2010-01-01";
  //   const endOfMonth = "2050-01-01";


  //   useBoundStore.getState().setRSFSCardFilters({
  //     datemodified: {
  //       start_date: startOfMonth,
  //       end_date: endOfMonth,
  //     },
  //     selectedFilterOption: value,
  //     selectedButton: 'AllBFiles'
  //   });


  //   this.setState({
  //     start_date: startOfMonth,
  //     end_date: endOfMonth,
  //     selectedButton: 'AllBFiles'
  //   });

  //   this.getStatsData();
  // }




  onSearchAgency = (index, value) => {
    this.setState(
      {
        search: value,
      },
      () => debounceQuery(this.search(index, value))
    );
  };

  render() {
    const {
      start_date,
      end_date,
      period,
      user,
      loading,
      isLoading,
      buckets,
      agencies,
      stats,
      stats_loading,
      typeOfCall,
      dedicated_agency_modal,
      agency_id
    } = this.state;



    const dateFormat = "MM-DD-YYYY";

    let defaultFromDate = new Date("2010-01-01");
    if (start_date) defaultFromDate = new Date(start_date);

    let defaultToDate = new Date("2050-01-01");
    if (end_date) defaultToDate = new Date(end_date);

    const handleRoleChange = (newRole) => {
      this.setState({
        buckets: this.getBucketOnHandleRoleChange(newRole),
        role: newRole,
        filterOption: newRole === REVIEWSCHEDULER ? this.rsFilter() : this.fsFilter(),
        selectedButton: "AllBFiles",
      });

      useBoundStore.getState().setRSFSCardFilters({
        selectedToggle: newRole,
        selectedToggleAPI: newRole,
        selectedAgency: undefined,
        selectedAgencyName: undefined,
        datemodified: {
          start_date: "2010-01-01",
          end_date: "2050-01-01",
        },
        selectedFilterOption: 'AllBFiles',
        selectedButton: "AllBFiles",
        hideBadPhoneNumber : 1
      });
      this.getStatsData();
    };






    const onFilterChange = (value) => {
      if (!value) {
        value = undefined;
      }
      this.setState({
        selectedFilterOption: value
      });


      useBoundStore.getState().setRSFSCardFilters({ selectedFilterOption: value });
      this.getStatsData();

    }

    const selectAgency = (value, name) => {
      this.setState({ selectedAgency: value });
      useBoundStore.getState().setRSFSCardFilters({ selectedAgency: value, selectedAgencyName: name });
      useBoundStore.getState().setRSFSFilters({ selectedAgency: value, selectedAgencyName: name });
      this.getStatsData();
    };

    const handleDateChange = (date, dateType) => {

      useBoundStore.getState().setRSFSCardFilters({
        selectedButton: 'None'
      });

      this.setState({
        selectedButton: 'None'
      });

      const formattedDate = date ? moment(date).format("YYYY-MM-DD") : null;

      this.setState((prevState) => {
        const updatedStartDate = dateType === "start_date" ? formattedDate : prevState.start_date;
        const updatedEndDate = dateType === "end_date" ? formattedDate : prevState.end_date;

        return {
          start_date: updatedStartDate,
          end_date: updatedEndDate,
          datemodified: {
            ...prevState.datemodified,
            start_date: updatedStartDate,
            end_date: updatedEndDate,
          },
        };
      }, () => {
        useBoundStore.getState().setRSFSCardFilters({
          datemodified: {
            start_date: this.state.start_date || formattedDate,
            end_date: this.state.end_date || formattedDate,
          },
        });

        if (this.state.start_date && this.state.end_date) {
          this.getStatsData();
        }
      });
    };


    const handleRangeChange = (dates) => {

      useBoundStore.getState().setRSFSCardFilters({
        selectedButton: 'None'
      });

      this.setState({
        selectedButton: 'None'
      });

      const start = dates && dates[0]
        ? moment(dates[0]).format("YYYY-MM-DD")
        : null;

      const end = dates && dates[1]
        ? moment(dates[1]).format("YYYY-MM-DD")
        : null;

      this.setState((prevState) => ({
        start_date: start,
        end_date: end,
        datemodified: {
          ...prevState.datemodified,
          start_date: start,
          end_date: end,
        },
      }), () => {

        useBoundStore.getState().setRSFSCardFilters({
          datemodified: {
            start_date: start,
            end_date: end,
          },
        });


        if (start && end) {
          this.getStatsData();
        }

      });
    };

    return (
      <div>
        <CommonHeader user={this.props.auth.user} onRoleChange={handleRoleChange} isHidden={false} />

        <div className=" container-filter" style={{ display: "flex", justifyContent: "space-between" }}>



          <div className="left-filter-container" style={{
            marginTop: "20px",
            display: "flex",
            justifyContent: "start",
            gap: "10px",
            width: (this.state.selectedToggleAPI === REVIEWSCHEDULER || this.showAllBFilesButton()) ? "40%" : "45%"
          }}>


            {
              (this.showSelectionFilterOptionDropdown()) &&
              (
                <div style={{ position: "relative" }}>
                  <Select
                    allowClear
                    showSearch
                    className="dropDown custom-select my-select-dropdown ovverides dropDown-ovveride"
                    placeholder="Select Filter"
                    optionFilterProp="children"
                    onChange={onFilterChange}
                    filterOption={(input, option) =>
                      option.props.children && option.props.children.toLowerCase().includes(input.toLowerCase())
                    }
                    value={this.state.selectedFilterOption}

                  >
                    {this.state.filterOption.map((opt) => (
                      <Option key={opt.id} value={opt.key} style={{ fontSize: "12px" }}>
                        {opt.value}
                      </Option>
                    ))}
                  </Select>
                </div>
              )}


            {
              (this.showAllBFilesButton()) &&
              (
                <div>
                  <Button
                    className={this.state.selectedButton === "AllBFiles" ? "bgPrimary " : "bgGray"}
                    onClick={this.handleAllBFiles.bind(this)}
                  >
                    All B Files
                  </Button>
                </div>
              )}

            <Button
              className={this.state.selectedButton === "ThisMonth" ? "bgPrimary ovverides" : "bgGray ovverides"}
              onClick={this.handleThisMonth.bind(this)}
            >
              This Month
            </Button>
            <div style={{ position: 'relative' }}>
              <Select
                allowClear
                showSearch
                className='custom-select my-select-dropdown'
                style={{
                  width: '189px',
                  fontSize: '12px',
                  backgroundColor: 'white',
                  borderRadius: '20px',
                  // marginTop: '12px',
                  // height: "28px",
                  // color: black;
                  fontWeight: 500
                }}
                placeholder="Search By Agency"
                optionFilterProp="children"
                onChange={(value, option) => {
                  let agencyId = value;
                  let agencyName = "";
                  if (option && option.props && option.props.children) {
                    agencyName = option.props.children;
                  }
                  selectAgency(agencyId, agencyName);
                }}
                filterOption={(input, option) =>
                  option.props.children && option.props.children.toLowerCase().includes(input.toLowerCase())}
                value={this.state.selectedAgency}
              >
                {agencies.map((opt) => (
                  <Option key={opt.id} value={opt.id}
                    style={{ fontSize: '12px' }}>
                    {opt.name}
                  </Option>
                ))}
              </Select>
            </div>
          </div>

          <div className="right-filter-container" style={{
            display: "flex",
            justifyContent: "end",
            gap: "10px",
          }}>

            <label
            className = 'hide-bad-phone-number-label'
            >
              <input
                type="checkbox"
                checked={Boolean(this.state.hideBadPhoneNumber)}
                onChange={this.handleBadPhoneNumberToggle}
                style={{
                  width: "13px",
                  height: "13px",
                  cursor: "pointer",
                  accentColor: this.state.hideBadPhoneNumber ? "#1890ff" : "#9ca3af"
                }}
              />
              <span >Hide Bad Phone Number</span>
            </label>

            <div className="datepicker" style={{ flexDirection: "column", marginTop: "4px" }}>
              {/* <div className='datepicker-label-rsfs'>Select Date Range</div> */}

              <DatePicker.RangePicker
                style={{ width: 300 }}
                dropdownClassName="custom-range-picker" //for header
                open={this.state.open}
                // onOpenChange={(status) => this.setState({ open: status })}
                onOpenChange={(status) => {
                  if (!status) return;
                  this.setState({ open: true })
                }
                }
                value={[
                  this.state.datemodified.start_date ? moment(this.state.datemodified.start_date) : null,
                  this.state.datemodified.end_date ? moment(this.state.datemodified.end_date) : null
                ]}
                format={dateFormat}
                onChange={(dates) => {
                  if (dates && dates.length === 2) {
                    const start = dates[0].format("YYYY-MM-DD");
                    const end = dates[1].format("YYYY-MM-DD");
                    this.setState({
                      datemodified: {
                        ...this.state.datemodified,
                        start_date: start,
                        end_date: end
                      }
                    });
                    this.setState({ open: true });
                  }
                }}
                renderExtraFooter={() => {
                  const start = this.state.datemodified.start_date
                    ? moment(this.state.datemodified.start_date)
                    : moment();

                  const end = this.state.datemodified.end_date
                    ? moment(this.state.datemodified.end_date)
                    : moment();

                  return (
                    <div style={{
                      display: 'flex',
                      justifyContent: 'space-between', gap: 20
                    }}>

                      {/* START CONTROLS */}
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                        <div style={{ fontSize: 12, marginBottom: '-7px' }}>Start</div>

                        <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                          <Select
                            showSearch
                            value={start.month()}
                            style={{ width: 100 }}
                            // className="dateRangedropDown custom-select"
                            onChange={(month) => {
                              const newDate = start.clone().month(month);


                              this.setState({
                                datemodified: {
                                  ...this.state.datemodified,
                                  start_date: newDate
                                }
                              });

                            }}
                            filterOption={(input, option) =>
                              option.props.children &&
                              option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                            }
                          >
                            {F.getMonthNames().map((m, i) => (
                              <Option key={i} value={i}>{m}</Option>
                            ))}
                          </Select>

                          <Select
                            showSearch
                            value={start.year()}
                            // className="dateRangedropDown custom-select"
                            style={{ width: 80 }}
                            onChange={(year) => {
                              const newDate = start.clone().year(year);
                              this.setState({
                                datemodified: {
                                  ...this.state.datemodified,
                                  start_date: newDate
                                }
                              });
                            }}
                            filterOption={(input, option) =>
                              option.props.children &&
                              option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                            }
                          >
                            {F.getYears().map((y) => (
                              <Option key={y} value={y}>{y}</Option>
                            ))}
                          </Select>
                        </div>
                      </div>

                      {/* END CONTROLS */}
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
                        <div style={{ fontSize: 12, marginBottom: '-7px' }}>End</div>

                        <div style={{ display: "flex", gap: 6, marginBottom: '15px' }}>
                          <Select
                            showSearch
                            value={end.month()}
                            style={{ width: 100 }}
                            // className="dateRangedropDown custom-select"
                            onChange={(month) => {
                              const newDate = end.clone().month(month);
                              this.setState({
                                datemodified: {
                                  ...this.state.datemodified,
                                  end_date: newDate
                                }
                              });

                            }}
                            filterOption={(input, option) =>
                              option.props.children &&
                              option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                            }
                          >
                            {F.getMomentMonths().map((m, i) => (
                              <Option key={i} value={i}>{m}</Option>
                            ))}
                          </Select>

                          <Select
                            showSearch
                            value={end.year()}
                            style={{ width: 80 }}
                            // className="dateRangedropDown custom-select"
                            onChange={(year) => {
                              const newDate = end.clone().year(year);
                              this.setState({
                                datemodified: {
                                  ...this.state.datemodified,
                                  end_date: newDate
                                }
                              });
                            }}
                            filterOption={(input, option) =>
                              option.props.children &&
                              option.props.children.toString().toLowerCase().includes(input.toLowerCase())
                            }
                          >
                            {F.getYears().map((y) => (
                              <Option key={y} value={y}>{y}</Option>
                            ))}
                          </Select>
                        </div>
                      </div>

                      {/* TODAY BUTTON */}
                      <div
                        style={{
                          alignSelf: 'center', cursor: 'pointer',
                          color: '#1890ff',
                          marginTop: '10px'
                        }}
                        onClick={() => {
                          const today = moment().format("YYYY-MM-DD");

                          this.setState({
                            datemodified: {
                              ...this.state.datemodified,
                              start_date: today,
                              end_date: today
                            }
                          });

                          // setOpen(false);
                        }}
                      >
                        Today
                      </div>

                      {/* VIEW BUTTON */}

                      <div
                        style={{
                          alignSelf: 'center'
                        }}>
                        <Button type="primary"
                          className="borderRadius-28 bg-164897"
                          style={{ marginTop: '15px' }}
                          onClick={() => {

                            this.setState({
                              datemodified: {
                                ...this.state.datemodified,
                                start_date: this.state.datemodified.start_date,
                                end_date: this.state.datemodified.end_date
                              }
                            });

                            handleRangeChange([this.state.datemodified.start_date,
                            this.state.datemodified.end_date]);
                            this.setState({ open: false });
                          }}
                        >
                          <Translate text={"Apply"}></Translate>
                        </Button>
                      </div>
                    </div>
                  );
                }}
              />

            </div>
            {/* <div style={{marginTop:"10px"}}  >
                   <Select
                    allowClear
                    showSearch
                    className='custom-select my-select-dropdown'
                    style={{
                      width: '189px',
                      fontSize: '12px',
                      backgroundColor: 'white',
                      borderRadius: '20px',
                      marginTop: '12px',
                      // height: "28px",
                      // color: black;
                      fontWeight: 500
                    }}
                    placeholder="Search By Agency"
                    optionFilterProp="children"
                    onChange={selectAgency}
                    filterOption={(input, option) => option.props.children.toLowerCase().includes(input.toLowerCase())}
                    value={this.state.selectedAgency}
                  >
                    {agencies.map((opt) => (
                      <Option key={opt.id} value={opt.id}
                        style={{ fontSize: '12px' }}>
                        {opt.name}
                      </Option>
                    ))}
                  </Select>
                </div> */}
            {/* <div className="datepicker" style={{ flexDirection: "column", marginTop: "4px" }} >
              <div className='datepicker-label-rsfs'>Start Date</div>
              <DatePicker
                className='custom-datepicker '
                value={this.state.datemodified.start_date
                  ? moment(this.state.datemodified.start_date)
                  : null}
                format={dateFormat}
                onChange={(e) => {
                  const newDate = e ? e : moment();
                  handleDateChange(newDate, 'start_date');
                }} />
            </div>
            <div className="datepicker" style={{ flexDirection: "column", marginTop: "4px" }}>
              <div className='datepicker-label-rsfs'>End Date</div>
              <DatePicker
                value={this.state.datemodified.end_date
                  ? moment(this.state.datemodified.end_date)
                  : null}
                format={dateFormat}
                onChange={(e) => {
                  const newDate = e ? e : moment();
                  handleDateChange(newDate, "end_date");
                }} />
            </div> */}
            <div>
              <Button
                onClick={this.handleRefresh}
                type="primary"
                className="bgPrimary refresh-height vonboard-refresh-button"
                style={{ marginTop: '22px', height: "28px" }}
              ><Icon type="reload" /> </Button>
            </div>
          </div>
        </div>
        <div className="mt-10">
          <Spin indicator={antIcon} spinning={isLoading}>
            <Row gutter={[16, 16]}>
              {buckets
                .sort((a, b) => a.order - b.order)
                .map((bucket) => (
                  <Col xs={24} sm={12} md={12} key={bucket.index}>
                    <div
                      className="hoverable-card"
                      role="button"
                      tabIndex="0"
                      onClick={() => {
                        if (bucket.isClickable) {
                          this.handleCardClick(bucket, bucket.index)
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          this.handleCardClick(bucket, bucket.index);
                        }
                      }}
                      style={{
                        display: "inline-flex",
                        height: "140px",
                        padding: "17px 18px 17px 27px",
                        width: "100%",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        gap: "58px",
                        flexShrink: "0",
                        borderRadius: "12px",
                        background: "#FFF"
                      }}
                    >
                      <div style={{
                        display: "inline-flex", alignItems: "center"
                        , cursor: bucket.isClickable ? "pointer" : "default"
                      }}>
                        <div style={{ width: "50px", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", marginLeft: "16px" }}>
                          <img src={bucket.icon} style={{ maxHeight: "50px" }} />
                        </div>
                        <div style={{ marginLeft: "48px" }}>
                          <h4 style={{ fontWeight: "600", marginTop: "20px" }}>{bucket.title}</h4>
                          <p style={{ fontSize: '12px' }}>{bucket.description || "No description available."}</p>
                          <p>
                            <small style={{ fontWeight: "bold", fontSize: '12px' }}>Total Calls : </small>
                            <span style={{
                              color: "#164897",
                              fontWeight: "bold",
                              marginLeft: "7px",
                              fontSize: '18px'
                            }}>{bucket.calls}</span>
                          </p>
                        </div>
                      </div>



                    </div>
                  </Col>
                ))}
            </Row>
          </Spin>
        </div>

        <AgencyModal
          history={this.props.history}
          showModal={dedicated_agency_modal}
          hideModal={() => {
            // this.props.history.push("/dashboard");
            this.setState({ dedicated_agency_modal: false });
            this.props.history.replace("/dashboard");
          }}
          onSelectAgency={this.onSelectAgency}
        />
      </div >

    );
  }
}

export default Vonboard;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/vonboard.js